<template>
  <div
    v-show="carregandoLocalizacao"
    style="max-height: 100vh; overflow: hidden"
    class="absolute bg-blue-900 flex-col bg-opacity-30 flex inset-0 items-center justify-center text-white z-50 z-index-30"
  >
    <div
      v-if="categoria"
      class="efeito-flutuante rounded-full w-64 h-64 flex items-center flex-col justify-center text-gray-800 bg-white"
    >
      <img class="w-48" :src="`${imageUrl}/pin-localizador/${pinName}.svg`" />
      <div class="text-xl p-4">Buscando...</div>
    </div>
  </div>
  <div>
    <GMapMap
      :center="center"
      :zoom="zoom"
      map-type-id="roadmap"
      ref="myMapRef"
      class="mapa"
      :class="{ 'mapa-open': selectedMarker && selectedMarker.extra.products }"
      :options="{
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        gestureHandling: 'greedy',
      }"
    >
      <GMapMarker
        v-if="userLocationMarker"
        :key="userLocationMarker.id"
        :position="userLocationMarker.position"
        :clickable="true"
        @click="center = userLocationMarker.position"
      >
        <GMapInfoWindow>
          <div>Você está aqui!</div>
        </GMapInfoWindow>
      </GMapMarker>
      <GMapCluster
        v-if="mapsInstance && mapsInstance.maps"
        :zoomOnClick="true"
        :minimumClusterSize="12"
      >
        <GMapMarker
          :key="marker.id"
          v-for="marker in markers"
          :position="marker.position"
          :clickable="true"
          :icon="{
            url: `${imageUrl}/pin-localizador/${pinName}-pin.svg`,
            scaledSize: new mapsInstance.maps.Size(44, 44),
          }"
          @click="markerClick(marker)"
        >
          <GMapInfoWindow
            :opened="marker.open"
            :options="{
              maxWidth: 320,
              maxHeight: 320,
            }"
            :zIndex="99"
            @closeclick="closeClick($event, marker)"
            v-if="marker.extra"
          >
            <div>SELECIONADO</div>
          </GMapInfoWindow>
        </GMapMarker>
      </GMapCluster>
    </GMapMap>

    <!-- Exibição do estabelecimento selecionado -->
    <div
      v-if="selectedMarker && selectedMarker.extra.products"
      class="absolute border-b transition-all shadow border-blue-900 text-sm top-0 sm:bottom-0 md:top-auto bg-white w-full h-1/2 md:h-72 overflow-scroll"
    >
      <h2 class="text-lg bg-blue-900 text-white p-2 pl-2 relative">
        {{ selectedMarker.extra.fantasia }}
        <span
          @click="markerClick(selectedMarker)"
          class="text-white w-10 h-8 bg-gray-800 flex justify-center items-center fixed md:absolute right-0 top-0 cursor-pointer"
          >X</span
        >
      </h2>
      <div class="bg-blue-900 text-white pl-2">
        {{ selectedMarker.extra.endereco }}, {{ selectedMarker.extra.numero }},
        <span v-if="selectedMarker.extra.complemento"
          >{{ selectedMarker.extra.complemento }},</span
        >
        {{ selectedMarker.extra.bairro }} - {{ selectedMarker.extra.cidade }} -
        {{ selectedMarker.extra.uf }} <br />
        <a
          class="hover:underline bg-blue-700 border border-blue-300 px-2 py-1 rounded inline-block my-2 mr-1"
          :href="`tel:${selectedMarker.extra.telefone_raw}`"
        >
          TEL: {{ selectedMarker.extra.telefone }}</a
        >

        <a
          :href="`https://www.google.com/maps/dir/?api=1&origin=${userLocationMarker.position.lat},${userLocationMarker.position.lng}&destination=${selectedMarker.position.lat},${selectedMarker.position.lng}&travelmode=driving`"
          target="_blank"
          class="hover:underline bg-blue-700 border border-blue-300 px-2 py-1 rounded inline-block my-2 mx-1"
          >ROTA</a
        >
        <a
          v-if="selectedMarker.extra.website"
          :href="selectedMarker.extra.website"
          target="_blank"
          class="hover:underline bg-blue-700 border border-blue-300 px-2 py-1 rounded inline-block my-2 mx-1"
          >SITE</a
        >
      </div>
      <div
        class="w-full grid grid-cols-2 p-2 md:grid-cols-6 lg:grid-cols-8 grid-flow-row gap-4"
      >
        <div
          v-for="product in selectedMarker.extra.products"
          :key="product.codigo"
          class="flex flex-col text-center text-xs items-center"
        >
          <img
            class="w-24 h-auto"
            :src="`${imageUrl}/imagens-produtos/${product.codigo}.png`"
          />
          {{ product.descricao }}
        </div>
      </div>

      <svg
        fill="none"
        :class="{
          hidden: selectedMarker.extra.products.length < 2,
          'md:hidden': selectedMarker.extra.products.length < 8,
        }"
        height="24"
        class="absolute bottom-0 efeito-flutuante2 right-1/2"
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6 9l6 6 6-6" />
      </svg>
    </div>

    <!-- Espaço para troca de Produto / Localização -->
    <div
      :class="{
        ' md:visible invisible': selectedMarker,
      }"
      class="absolute z-10 w-full sm:w-full md:w-1/2 lg:w-1/3 md:mr-2 top-0 p-3 text-white bg-blue-900 rounded-b right-0"
    >
      <div class="flex">
        <div class="w-1/2">
          <button
            v-if="produtoInfo"
            class="w-full flex flex-col hover:bg-blue-800 items-center justify-center mb-2 rounded text-sm"
            @click="clearProdutos()"
          >
            <div class="flex">
              <img
                v-for="produtoSel in produto"
                :key="produtoSel"
                class="w-12 h-12 object-contain bg-gray-100 rounded mr-1"
                :src="`${imageUrl}/imagens-produtos/${produtoSel}.png`"
              />
            </div>
          </button>

          <div class="px-3 mt-3 text-center flex flex-wrap text-xs">
            <div class="w-full uppercase text-center">Buscar em até:</div>
            <div class="w-1/2">
              <label
                class="p-1 m-2 block rounded uppercase"
                :class="{ 'bg-white text-green-800': dist == 2, 'bg-green-800': dist != 2}"
                @click="dist = 2"
              >
                2km
              </label>
            </div>
            <div class="w-1/2">
              <label
                class="p-1 m-2 block rounded uppercase"
                :class="{ 'bg-white text-green-800': dist == 5, 'bg-green-800': dist != 5}"
                @click="dist = 5"
              >
                5km
              </label>
            </div>
            <div class="w-1/2">
              <label
                class="p-1 m-2 block rounded uppercase"
                :class="{ 'bg-white text-green-800': dist == 10, 'bg-green-800': dist != 10}"
                @click="dist = 10"
              >
                10km
              </label>
            </div>
            <div class="w-1/2">
              <label
                class="p-1 m-2 block rounded uppercase"
                :class="{ 'bg-white text-green-800': dist == 20, 'bg-green-800': dist != 20}"
                @click="dist = 20"
              >
                20km
              </label>
            </div>
          </div>
        </div>
        <div class="w-1/2">
          <div
            v-if="autocomplete"
          >
            <div
              class="border text-sm bg-gray-100 p-1 mb-1 w-full rounded h-7 text-gray-800 flex items-baseline overflow-hidden text-center justify-center"
            @click="clear"
            >
              {{ autocomplete.value }}
            </div>
          <button
            class="mb-2 uppercase text-xs mt-2 mx-auto w-full hover:bg-green-800 bg-green-700 px-2 py-2 rounded block"
            @click="clear"
          >
            Alterar <br/>Localização
          </button>
          </div>
          <button
            class="mb-2 uppercase text-xs mt-4 mx-auto w-full hover:bg-red-800 bg-red-700 px-2 py-2 rounded block"
            @click="clearProdutos"
          >
            Fazer uma <br/>nova busca
          </button>
        </div>
      </div>
      <div class="uppercase text-center text-sm mt-4 font-bold">
        Escolha o mercado de sua preferência!
      </div>
    </div>

    <!-- 1 - Dados do Visitante -->
    <div
      v-if="!visitante.status"
      class="absolute bg-blue-900 bg-opacity-95 flex flex-col inset-0 items-center text-white z-50 z-index-30"
    >

      <h3 class="text-lg text-white text-center font-bold uppercase mt-10" v-html="fraseEntrada"></h3>
      <div> 
        <img class="w-20 mt-2" :src="`${imageUrl}/pin-localizador/${pinName}-pin-branco.svg`" />
      </div>
 
      <div class="p-4 w-full md:w-1/3 uppercase text-sm">
        <div
          v-if="visitanteFormError"
          class="bg-red-100 rounded text-red-900 border boder-red-200 p-2"
        >
          <ul class="list-inside list-disc">
            <li v-for="(error, index) in visitanteFormError" :key="index">
              {{ error }}
            </li>
          </ul>
        </div>
        <div class="mt-2 w-full">
          <label>E-mail</label>
          <input
            type="email"
            required=""
            v-model="visitante.email"
            @blur="visitanteCheckEmail()"
            class="w-full rounded p-2 border text-blue-900 uppercase text-sm"
            placeholder="Qual o seu melhor email?"
          />
        </div>
        <div class="mt-4 w-full">
          <label>Seu Nome</label>
          <input
            type="text"
            required
            v-model="visitante.nome"
            class="w-full rounded p-2 border text-blue-900 uppercase text-sm"
            placeholder="Como você quer ser chamado?"
          />
        </div>
        <button
          class="mb-2 uppercase font-bold mt-6 mx-auto w-2/3 hover:bg-green-800 bg-green-700 border border-green-300 px-2 py-1 rounded block"
          @click="saveVisitante"
        >
          Continuar
        </button>
      </div>
      <div
        class="p-4 text-sm text-gray-200 text-center bg-gray-800 bg-opacity-75 mt-20 rounded"
      >
        Ao continuar, você concorda com nossa política de privacidade e o uso de
        cookies para personalizar sua experiência.
      </div>
      <div
        class="absolute bottom-0 p-4 text-center text-gray-200 text-sm w-full"
      >
        <span class="text-sm"></span>
        <div class="flex w-3/4 mx-auto mb-3 items-center justify-center">
          <div
            class="bg-gray-200 font-bold w-10 h-10 border rounded-full justify-center items-center text-gray-600 text-lg flex"
          >
            1
          </div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div class="w-5 h-1 bg-gray-600">&nbsp;</div>
          <div
            class="bg-gray-700 border-gray-600 w-10 h-10 border rounded-full justify-center items-center text-gray-100 text-lg flex"
          >
            2
          </div>
          <div class="w-10 h-1 bg-gray-600">&nbsp;</div>
          <div
            class="bg-gray-700 border-gray-600 w-10 h-10 border rounded-full justify-center items-center text-gray-100 text-lg flex"
          >
            3
          </div>
        </div>
      </div> 
    </div>

    <!-- 2 - Seletor Produto -->
    <div
      v-if="visitante.status && !produtosSelecionados"
      class="absolute bg-blue-900 bg-opacity-95 flex flex-col inset-0 items-center text-white z-50 z-index-30"
    >
      
      <h3 class="text-white font-bold text-center my-5">
        SELECIONE ATÉ 3 PRODUTOS <br/>PARA ENCONTRAR NO MAPA
      </h3>
      <button
        v-if="produto.length >= 1"
        class="mb-2 w-1/2 mx-auto hover:bg-green-800 bg-green-700 border border-green-300 uppercase px-2 py-1 rounded inline-block"
        @click="buscaProdutos"
      >
        Buscar ({{ produto.length }})
      </button>

      <div
        class="flex overflow-scroll flex-row flex-wrap text-center"
      >
        <div
          v-for="product in produtos"
          :key="product.codigo"
          class="text-sm w-1/3 md:1/3 lg:w-1/5 p-1"
        >
          <div
            @click="selectProduct(product)"
            :class="{ 'bg-gray-900': produto.includes(product.codigo) }"
            class="h-full overflow-hidden text-center text-xs lg:text-sm p-2 rounded cursor-pointer flex flex-col items-center"
          >
            <img
              class="w-20 h-20 lg:h-32 lg:w-32 mb-1 object-contain bg-gray-100 rounded"
              :src="`${imageUrl}/imagens-produtos/${product.codigo}.png`"
            />
            {{ product.descricao }}
          </div>
        </div>
      </div>
      <div
        class="p-4 text-sm text-gray-200 text-center w-full"
      >
        <span class="text-sm"></span>
        <div class="flex w-3/4 mx-auto mb-3 items-center justify-center">
          <div
            class="bg-gray-200 font-bold w-10 h-10 border rounded-full justify-center items-center text-gray-600 text-lg flex"
          >
            1
          </div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div
            class="bg-gray-200 font-bold border w-10 h-10 rounded-full justify-center items-center text-gray-600 text-lg flex"
          >
            2
          </div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div class="w-5 h-1 bg-gray-600">&nbsp;</div>
          <div
            class="bg-gray-700 border-gray-600 w-10 h-10 border rounded-full justify-center items-center text-gray-100 text-lg flex"
          >
            3
          </div>
        </div>
      </div>
    </div>

    <!-- 3 - Localização -->
    <div
      v-show="visitante.status && produtosSelecionados && !userLocationMarker"
      class="absolute bg-blue-900 bg-opacity-95 flex flex-col inset-0 items-center text-white z-50 z-index-30"
    >
      
      <h3 class="text-white uppercase font-bold text-center my-5">
        Agora, escolha uma <br/>cidade ou digite o seu cep
      </h3>
      <div class="p-4 mt-40 w-full md:w-1/3">
        <div class="relative">
          <input
            type="text"
            ref="autocomplete"
            class="w-full rounded p-2 border text-blue-900 text-sm uppercase text-center"
            placeholder="Digite uma cidade ou um cep"
          />
          <span
            v-if="userLocationAddress.city"
            @click="clear"
            class="cursor-pointer hover:bg-gray-500 bg-gray-300 absolute rounded-full w-6 h-6 flex justify-center top-2 right-2 text-blue-900 items-center"
            >X</span
          >
        </div>
        <p class="text-center col-start-auto mt-4 text-sm font-bold">OU</p>
        <button
          class="mb-2 mt-4 text-sm uppercase w-full hover:bg-green-800 bg-green-700 border border-green-300 px-2 py-1 rounded inline-block mr-2"
          @click="getLocation"
        >
          Carregar os mercados mais perto de mim
        </button>
      </div>
      <div
        class="absolute bottom-0 p-4 text-center text-gray-200 text-sm w-full"
      >
        <span class="text-sm"></span>
        <div class="flex w-3/4 mx-auto mb-3 items-center justify-center">
          <div
            class="bg-gray-200 font-bold w-10 h-10 border rounded-full justify-center items-center text-gray-600 text-lg flex"
          >
            1
          </div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div
            class="bg-gray-200 font-bold w-10 h-10 border rounded-full justify-center items-center text-gray-600 text-lg flex"
          >
            2
          </div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div class="w-5 h-1 bg-gray-200">&nbsp;</div>
          <div
            class="bg-gray-200 border w-10 h-10 rounded-full justify-center items-center text-gray-600 font-bold text-lg flex"
          >
            3
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="
        visitante.status &&
        produtosSelecionados &&
        userLocationMarker &&
        !carregandoLocalizacao &&
        markers.length == 0
      "
      class="absolute bg-opacity-90 bg-white border border-blue-900 bottom-0 flex h-screen items-center justify-center mx-auto p-2 pt-52 text-center w-full z-0"
    >
      <div v-if="dist == 20">
        Parece que os produtos selecionados não estão disponíveis em sua região.
        <br />
        <span class="italic">
          Estou enviando um lembrete ao time de vendas sobre a sua procura.
        </span>
        <br /><br />
        A qualquer momento, você pode alterar a
        <span class="underline font-bold cursor-pointer" @click="clear">
          localização
        </span>
        ou
        <span
          class="underline font-bold cursor-pointer"
          @click="clearProdutos()"
        >
          os produtos buscados </span
        >.
      </div>
      <div v-else>
        Parece que os produtos selecionados não estão disponíveis em sua região,
        <b>tente aumentar seu raio de busca</b>.
      </div>
    </div>

    <!-- Link Amazon -->
    <div 
      v-if="linkAmazon"
      class="absolute bottom-4 right-4"
      :class="{'sm:bottom-80': selectedMarker && selectedMarker.extra.products }"
    >
      <a :href="linkAmazon" target="_blank">
        <img
          class="md:w-48 w-36"
          :src="`${imageUrl}/localizador/botao-compre-amazon.png`"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, nextTick } from "vue";
import axios from "axios";
import { getEnv } from "@/utils";
export default {
  setup() {
    /**
     * API Config
     */
    const apiUrl = getEnv("VUE_APP_API_URL");
    const imageUrl = getEnv("VUE_APP_IMAGE_URL");
    const pinName = getEnv("VUE_APP_PIN_NAME");
    const categorias = getEnv("VUE_APP_CATEGORIAS");
    const mapsApiKey = getEnv("VUE_APP_MAP_API_KEY");
    const fraseEntrada = getEnv("VUE_APP_FRASE_ENTRADA");
    const linkAmazon = getEnv("VUE_APP_LINK_AMAZON") ?? null;
    const skipVisitante = getEnv("VUE_APP_SKIP_VISITANTE") === "true";

    /**
     * Outros
     */

    const center = ref({
      lat: parseFloat(getEnv("VUE_APP_MAP_CENTER_LAT")),
      lng: parseFloat(getEnv("VUE_APP_MAP_CENTER_LNG")),
    });
    const userLocationMarker = ref();
    const myMapRef = ref();
    const autocomplete = ref();
    const autoComp = ref();
    const places = ref();
    const zoom = ref(12);
    const selectedMarker = ref();

    /**
     * HELPER
     */
    //const getMeta = (metaName) => {
    //  const metas = document.getElementsByTagName("meta");

    //  for (let i = 0; i < metas.length; i++) {
    //    if (metas[i].getAttribute("name") === metaName) {
    //      return metas[i].getAttribute("content");
    //    }
    //  }
    //  return "";
    //};

    const debug = () => {
      let a = myMapRef.value;
      console.log(a);
      debugger;
    };

    const userLocationAddress = ref({
      city: "",
      state: "",
      postal_code: "",
    });
    const carregandoLocalizacao = ref(false);

    const setUserLocationMarker = (coords) => {
      userLocationMarker.value = {
        id: "userLocationMarker",
        position: coords,
      };
    };

    const markers = ref([
      {
        id: "dfsldjl3r",
        position: {
          lat: 51.093048,
          lng: 6.84212,
        },
      },
    ]);

    const mapsInstance = ref();

    const getLocation = async () => {
      dist.value = 20;
      if (navigator.geolocation) {
        carregandoLocalizacao.value = true;
        await navigator.geolocation.getCurrentPosition(
          function (position) {
            carregandoLocalizacao.value = false;
            let coords = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            setUserLocationMarker(coords);
            getLocationInfo(coords);
            centerMap(coords);
          },
          function (error) {
            carregandoLocalizacao.value = false;
            if (error.code == error.PERMISSION_DENIED)
              alert(
                "Você precisa habilitar a geolocalização do seu navegador ou digitar o seu endereço."
              );
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    };

    const centerMap = (coords) => {
      center.value = coords;
    };

    const updateAutoComp = () => {
      const place = autoComp.value.getPlace();

      const coords = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      centerMap(coords);
      setUserLocationMarker(coords);
      processLocationInfo(place);
    };
    const dist = ref(20);

    watch(dist, () => {
      loadMarkers();
    });

    watch(myMapRef, (googleMap) => {
      if (googleMap) {
        googleMap.$mapPromise.then((map) => {
          let google = window.google;
          mapsInstance.value = window.google;
          places.value = new google.maps.places.PlacesService(map);
          var options = {
            componentRestrictions: { country: "br" },
          };
          autoComp.value = new google.maps.places.Autocomplete(
            autocomplete.value,
            options
          );
          autoComp.value.addListener("place_changed", updateAutoComp);

          map.setOptions({
            styles: [
              {
                featureType: "poi",
                stylers: [
                  {
                    visibility: "off",
                  },
                ],
              },
            ],
          });
        });
      }
    });

    const processLocationInfo = (location) => {
      const info = location.address_components;
      const admAreaLvl2 = info.filter(function (address_component) {
        return address_component.types.includes("administrative_area_level_2");
      });
      const admAreaLvl1 = info.filter(function (address_component) {
        return address_component.types.includes("administrative_area_level_1");
      });
      const postalCode = info.filter(function (address_component) {
        return address_component.types.includes("postal_code");
      });
      userLocationAddress.value.city = admAreaLvl2[0].long_name;
      userLocationAddress.value.state = admAreaLvl1[0].short_name;
      userLocationAddress.value.postal_code = null;
      if (postalCode.length > 0) {
        userLocationAddress.value.postal_code = postalCode[0].long_name;
      }
      dist.value = 20;
      loadMarkers();
    };

    const getLocationInfo = async (coords) => {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${coords.lat},${coords.lng}&key=${mapsApiKey}`
      );
      processLocationInfo(response.data.results[0]);
      autocomplete.value.value = response.data.results[0].formatted_address;
    };

    const loadMarkers = async () => {
      console.log(produto.value, userLocationMarker.value);
      if (!userLocationMarker.value) {
        return;
      }
      selectedMarker.value = null;
      carregandoLocalizacao.value = true;

      const response = await axios.get(
        `${apiUrl}?cep=${userLocationAddress.value.postal_code}&cidade=${
          userLocationAddress.value.city
        }&produto=${produto.value.join(",")}&userLat=${
          userLocationMarker.value.position.lat
        }&userLng=${userLocationMarker.value.position.lng}&dist=${
          dist.value
        }&visitante=${visitante.value.ukey}`
      );
      const responseMarkers = response.data.map((item) => {
        let point = [];
        point["id"] = item.a03_ukey;
        point["extra"] = item;
        point["open"] = false;
        point["position"] = {
          lat: parseFloat(item.latitude),
          lng: parseFloat(item.longitude),
        };
        return point;
      });

      markers.value = responseMarkers;
      zoom.value = 12;
      carregandoLocalizacao.value = false;
    };

    onMounted(async () => {
      mapsInstance.value = window.google;
      const urlParams = new URLSearchParams(window.location.search);
      categoria.value = {
        ukeys: categorias,
      };
      await produtosPorCategoria();
      if (urlParams.get("produto")) {
        produto.value.push(urlParams.get("produto"));
        produtosSelecionados.value = true;
        // getCategoriaDoProduto();
        produtoInfo.value.push({
          codigo: produto.value,
          nome: "",
        });
        buscaProdutos();
      }

      readCookie();
    });

    const markerClick = async (mark) => {
      markers.value.forEach((item) => {
        if (item.id != mark.id) {
          item.open = false;
        }
      });
      if (mark.open) {
        mark.open = false;
        selectedMarker.value = null;
        return;
      }
      mark.open = true;
      const response = await axios.get(
        `${apiUrl}/${mark.id}?lat=${
          userLocationMarker.value.position.lat
        }&lng=${
          userLocationMarker.value.position.lng
        }&produto=${produto.value.join(",")}&visitante=${visitante.value.ukey}`
      );

      mark.extra.products = response.data;
      selectedMarker.value = mark;
    };

    const clear = async () => {
      userLocationMarker.value = null;
      autocomplete.value.value = "";
      userLocationAddress.value.city = "";
      await nextTick();
      autocomplete.value.focus();
    };

    const closeClick = (e, marker) => {
      console.log(e, marker);
    };

    /**
     * Passo 1 - Visitante
     */
    const visitante = ref({
      nome: "",
      email: "",
      status: skipVisitante ? 1 : 0,
      ukey: "",
    });
    const visitanteFormError = ref("");

    const visitanteCheckEmail = async () => {
      const response = await axios.get(
        `${apiUrl}/visitante-check?email=${visitante.value.email}`
      );
      if (response.data.status == "error") {
        let errors = [];

        Object.values(response.data.errors).forEach((element) => {
          errors.push(element[0]);
        });

        visitanteFormError.value = errors;
      } else {
        if (response.data.r24_002_c && response.data.ukey) {
          visitante.value.nome = response.data.r24_002_c;
          visitante.value.ukey = response.data.ukey;
        }
      }
    };
    const getCookie = (cname) => {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return null;
    };
    const storeCookie = () => {
      visitante.value.status = 1;
      var CookieDate = new Date();
      CookieDate.setFullYear(CookieDate.getFullYear() + 10);
      document.cookie = `visitante=${JSON.stringify(
        visitante.value
      )}; expires=${CookieDate.toUTCString()}`;
    };
    const readCookie = () => {
      let visitanteCookie = getCookie("visitante");
      if (visitanteCookie) {
        visitante.value = JSON.parse(visitanteCookie);
      }
    };

    const saveVisitante = async () => {
      if (visitante.value.ukey) {
        storeCookie();
        return;
      }
      const response = await axios.get(
        `${apiUrl}/visitante?email=${visitante.value.email}&nome=${visitante.value.nome}`
      );
      if (response.data.status == "error") {
        let errors = [];

        Object.values(response.data.errors).forEach((element) => {
          errors.push(element[0]);
        });

        visitanteFormError.value = errors;
      } else {
        visitante.value.ukey = response.data.ukey;
        if (visitante.value.ukey) {
          storeCookie();
        }
      }
    };

    /**
     * Passo 2 - Categorias e Produtos
     */
    const produto = ref([]);
    const produtoInfo = ref([]);
    const produtos = ref();
    const categoria = ref(null);
    const produtosSelecionados = ref(false);

    const removeProduct = (codigo) => {
      produto.value = produto.value.filter((value) => {
        return value != codigo;
      });
      produtoInfo.value = produtoInfo.value.filter((value) => {
        return value.codigo != codigo;
      });
    };

    const selectProduct = async (product) => {
      if (produto.value.includes(product.codigo)) {
        removeProduct(product.codigo);
        return;
      }
      if (produto.value.length < 3) {
        produto.value.push(product.codigo);
        produtoInfo.value.push(product);
      }
      if (produto.value.length == 3) {
        buscaProdutos();
      }
    };

    const buscaProdutos = async () => {
      if (produto.value.length == 0) {
        return;
      }
      dist.value = 20;
      produtosSelecionados.value = true;
      await nextTick();
      autocomplete.value.focus();
      loadMarkers();
    };

    const clearProdutos = () => {
      produtosSelecionados.value = false;
      produto.value = [];
      produtoInfo.value = [];
    };

    const produtosPorCategoria = async () => {
      clearProdutos();
      const response = await axios.get(
        `${apiUrl}/categorias/${categoria.value.ukeys}`
      );
      produtos.value = response.data;
    };
    // const getCategoriaDoProduto = async () => {
    //   const response = await axios.get(
    //     `${apiUrl}/categorias?produto=${produto.value[0]}`
    //   );
    //   categoria.value = response.data[0];
    // };

    /**
     * Returns
     */
    return {
      // API Config
      imageUrl,
      pinName,
      linkAmazon,
      fraseEntrada,
      // Outros
      center,
      markers,
      loadMarkers,
      getLocation,
      userLocationMarker,
      carregandoLocalizacao,
      userLocationAddress,
      markerClick,
      myMapRef,
      autocomplete,
      zoom,
      dist,
      clear,
      selectedMarker,
      closeClick,
      debug,
      mapsInstance,

      // Passo 2 - Produtos e Categorias
      produtos,
      produto,
      produtoInfo,
      categoria,
      produtosPorCategoria,
      selectProduct,
      buscaProdutos,
      produtosSelecionados,
      clearProdutos,
      // Passo 1 - Visitante
      visitante,
      saveVisitante,
      visitanteFormError,
      visitanteCheckEmail,
    };
  },
};
</script>
<style>
@keyframes float {
  0%,
  100% {
    transform: translatey(30px);
  }
  50% {
    transform: translatey(-30px);
  }
}
.efeito-flutuante {
  animation: float 3s ease-in-out infinite;
}

@keyframes float2 {
  0%,
  100% {
    transform: translatey(10px);
  }
  50% {
    transform: translatey(-10px);
  }
}
.efeito-flutuante2 {
  animation: float2 2s ease-in-out infinite;
}

button.gm-ui-hover-effect {
  display: none !important;
}

.mapa {
  width: 100vw;
  height: calc(100vh - 110px);
  margin-top: 110px;
  transition: all 300ms;
}
.mapa-open {
  height: 50vh;
  margin-top: 50vh;
}

@media (min-width: 740px) {
  .mapa {
    height: 100vh;
    margin-top: 0px;
  }
  .mapa-open {
    height: 100vh;
    margin-top: 0px;
  }
}

/* .pac-container {
  position: fixed;
  display: block;
  margin-top: -210px;
} */
</style>
